var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"avatar"},[_c('img',{attrs:{"src":_vm.student.image_url,"alt":_vm.student.username}}),(_vm.show_status)?_c('i',{staticClass:"avatar-presence",class:{ online: _vm.online }}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }